import { defineStore } from 'pinia'
import { PsapStatus } from '@interfaces/UserDetails'
import { OperatorStatus } from '@interfaces/UserDetails'
import { Role } from '@interfaces/UserDetails'
import {
  OperatorInterface,
  RoleInterface,
  UserLinksInterface,
  PsapInUserDetails,
  PsapIntegrator
} from '@interfaces/UserDetails'
import { UserDetails } from '@interfaces/UserDetails'
import {HrefTemplated} from "@interfaces/Paginations";
interface UserDetailExtended extends UserDetails {
  psapInRecevability?: boolean
  operatorInRecevability?: boolean
  canBecameHisOwnPsapIntegrator?: boolean
}
const useUserDetailsStore = defineStore({
  id: 'userDetailStore',
  state: (): UserDetailExtended => {
    return {
      name: '',
      operator: operatorInit,
      role: roleInit,
      psapInRecevability: false,
      operatorInRecevability: false,
      canBecameHisOwnPsapIntegrator: false,
      login: '',
      contactMail: '',
      firstName: '',
      psap: psapInit,
      _links: linksInit
    }
  },
  persist: true,
  getters: {
    getUserDetails: (state) => state,
    getName: (state) => state.name,
    getFirstName: (state) => state.firstName,
    getPsapInRecevability: (state) => state.psapInRecevability,
    getOperatorInRecevability: (state) => state.operatorInRecevability,
    getCanBecameHisOwnPsapIntegrator: (state) =>
      state.canBecameHisOwnPsapIntegrator,
    getOperator: (state) => state.operator,
    isAttachedToAPsap: (state) => !!state.psap,
    getPsapId: (state) => state.psap?.psapId,
    isAttachedToAnOperator: (state) => !!state.operator,
    getOperatorId: (state) => state.operator?.arcepOperatorId
  },
  actions: {
    setUser(user: UserDetails) {
      this.$state = user
      this.setMoreAttributes()
      sessionStorage.setItem('userDetailsExtended', JSON.stringify(this.$state))
    },
    initStore() {
      this.loadUserDetails()
    },
    loadUserDetails() {
      const storedDetails = sessionStorage.getItem('userDetailsExtended')
      if (storedDetails) {
        const userDetails = JSON.parse(storedDetails)
        Object.assign(this.$state, userDetails)
      }
    },

    setMoreAttributes() {
      if (this.psap) {
        this.psapInRecevability =
          this.psap.status === PsapStatus.RECEVABILITY_IN_PROGRESS
      } else {
        this.psapInRecevability = false
      }
      if (this.operator) {
        this.operatorInRecevability =
          this.operator.status === OperatorStatus.RECEVABILITY_IN_PROGRESS
      } else {
        this.operatorInRecevability = false
      }
      if (this.psap && this.role.roleId === Role.PSAP_MANAGER) {
        this.canBecameHisOwnPsapIntegrator =
          this.canBecameHisOwnPsapIntegratorFct()
      } else {
        this.canBecameHisOwnPsapIntegrator = false
      }
    },
    canBecameHisOwnPsapIntegratorFct() {
      if (
        (this.psap?.status === PsapStatus.CREATED_WITH_CAAU ||
          this.psap?.status === PsapStatus.RECEVABILITY_IN_PROGRESS) &&
        this.psap.psapIntegrator === null
      ) {
        return true
      }
      return false
    },
    deleteUserDetails() {
      this.$reset()
      sessionStorage.removeItem('userDetailsExtended')
    }
  }
})
export default useUserDetailsStore

const hrefTemplatedInit: HrefTemplated = {
  href: '',
  templated: false
}

const operatorInit: OperatorInterface = {
  getLocationSvhUrl: '',
  arcepOperatorId: '',
  isOpta: false,
  getAddressSvhUrl: '',
  getAddressUrl: '',
  status: '',
  notifyOperatorUrl: '',
  contactMail: '',
  startScheduledMaintenance: '',
  endScheduledMaintenance: '',
  dateUpdateStatus: '',
  addressesIp: '',
  slaGetAddressTimeResponse: 0,
  isMno: false,
  useRebound: false,
  msgScheduledMaintenance: '',
  isSvh: false,
  operReseauSvh: '',
  _links: {
    statsSlaPushlocations: {
      href: ''
    },
    statsSlaGetaddresses: {
      href: ''
    },
    agregStatsOperators: {
      href: ''
    },
    statsSlaGetlocationSVHs: {
      href: ''
    },
    operators: hrefTemplatedInit,
    users: hrefTemplatedInit,
    operatorRecevabilityStage: hrefTemplatedInit,
    vpnInfos: {
      href: ''
    },
    operator: [],
    operatorRecevability: hrefTemplatedInit,
    self: hrefTemplatedInit
  }
}

const roleInit: RoleInterface = {
  name: '',
  roleId: '',
  _links: {
    rightCreation: {
      href: ''
    },
    rights: {
      href: ''
    },
    users: hrefTemplatedInit,
    self: hrefTemplatedInit
  }
}
const linksInit: UserLinksInterface = {
  self: {
    href: ''
  },
  user: hrefTemplatedInit,
  role: hrefTemplatedInit,
  psapsForLoginMinisterProjectChief: hrefTemplatedInit,
  psap: hrefTemplatedInit,
  operator: hrefTemplatedInit,
  psapsForLoginPsapIntegrator: hrefTemplatedInit
}
const psapIntegratorInit: PsapIntegrator = {
  name: '',
  login: '',
  firstName: '',
  _links: {
    role: hrefTemplatedInit,
    psapsForLoginMinisterProjectChief: hrefTemplatedInit,
    psap: hrefTemplatedInit,
    operator: hrefTemplatedInit,
    psapsForLoginPsapIntegrator: hrefTemplatedInit,
    self: hrefTemplatedInit
  }
}
const psapInit: PsapInUserDetails = {
  psapId: '',
  status: '',
  psapIntegrator: psapIntegratorInit,
  isSvh: false,
  statusSvh: '',
  _links: {
    pullPsaps: {
      href: ''
    },
    users: hrefTemplatedInit,
    commonName: {
      href: ''
    },
    sslInfos: hrefTemplatedInit,
    agregStatsPsapPullReqPics: {
      href: ''
    },
    psapIntegrator: hrefTemplatedInit,
    numLongPsaps: hrefTemplatedInit,
    statsTerminalLocations: {
      href: ''
    },
    agregStatsPsapReqNumLongs: {
      href: ''
    },
    agregStatsPsapReqHeures: {
      href: ''
    },
    ministerProjectChief: hrefTemplatedInit,
    psapRecevability: hrefTemplatedInit,
    blockedPsaps: {
      href: ''
    },
    self: hrefTemplatedInit
  }
}
